import React from 'react'
import { Outlet } from 'react-router-dom'
import { Box } from '@mui/material'

export const BlankLayout = () => {
  return (
    <Box component='main' sx={{ minHeight: '100vh' }}>
      <Outlet />
    </Box>
  )
}
